import PropTypes from 'prop-types';
import React from 'react';
import {
  Card,
  CardHeader,
  withStyles,
} from '@material-ui/core';
import common from '@material-ui/core/colors/common';
import CloseIcon from '@material-ui/icons/Close';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const {white, black} = common;

const bgColor = {
  error: '#BB000A',
  info: '#000000',
  banner: '#F2F2F2',
};

const fontColor = {
  banner: black,
};

const styles = () => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    zIndex: 1401,
    ['@media only screen and (min-width: 756px)']: { // eslint-disable-line no-useless-computed-key
      paddingTop: '120px'
    }
  },
  clickTarget: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: '52px',
  },
});

const Alert = ({onClick, onClose, level = 'error', subtitle, title, icon, closeIcon, classes}) => {
  const style = {
    backgroundColor: bgColor[level] || '#000000',
  };
  const titleStyle = {
    color: fontColor[level] || white,
  };
  const subtitleStyle = {
    color: fontColor[level] || white,
    fontWeight: 400
  };

  let _closeIcon = (closeIcon !== undefined
    ? closeIcon
    : <CloseIcon style={{fill: fontColor[level] || white}} onClick={onClose} />
  );
  _closeIcon = onClose === null ? null : _closeIcon;
  return (
    <div className={classes.root}>
      <Card>
        <CardHeader
          style={style}
          title={title}
          subheader={subtitle}
          avatar={
            level === 'error'
              ? <ErrorOutlineIcon style={{fill: white, margin: '6px 12px 6px 0'}} />
              : (icon || null)
          }
          titleTypographyProps={{style: titleStyle}}
          subheaderTypographyProps={{style: subtitleStyle}}
          action={_closeIcon}
        />
        <div
          className={classes.clickTarget}
          onClick={onClick}
          style={{cursor: onClick ? 'pointer' : 'default'}}
        />
      </Card>
    </div>
  );
};

Alert.propTypes = {
  level: PropTypes.oneOf(['error', 'info']),
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  subtitle: PropTypes.node,
  title: PropTypes.node,
  icon: PropTypes.node,
  closeIcon: PropTypes.node,
  classes: PropTypes.object,
};

export default withStyles(styles)(Alert);



// WEBPACK FOOTER //
// ./src/ondemand/components/Alert/Alert.js